import {
  AssetRoutineState,
  RoutineWorkflow,
  Severity,
  WorkspaceRoutine,
} from '@gripp/shared-logic';
import { ReactNode } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { RoutineModules } from '../routineModules';
import { RoutineModule } from '../types';

type RoutineModuleButtonProps = {
  routine: WorkspaceRoutine;
  state?: AssetRoutineState<any>;
  buttonIndex: number;
  buttonCount: number;
  buttonStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  buttonIcon?: Severity;
  buttonIconStyle?: StyleProp<ViewStyle>;
  secondaryButtonIcon?: ReactNode;
  leftButtonIcon?: ReactNode;
  workflows?: RoutineWorkflow[];
  onClick: (
    routine: WorkspaceRoutine,
    module: RoutineModule<any, any>,
    state?: AssetRoutineState<any>,
    additionalState?: any,
    workflows?: RoutineWorkflow[]
  ) => void;
};

export const RoutineModuleButtonOld = (props: RoutineModuleButtonProps) => {
  const module = props.routine.type ? RoutineModules[props.routine.type] : undefined;
  const ModuleButtons = module?.buttons;
  
  if (!ModuleButtons) return null;

  return (
    <View
      key={props.routine.id}
      style={
        props.buttonIndex === props.buttonCount - 1 && props.buttonCount > 1
          ? { marginBottom: 0 }
          : { marginBottom: 16 }
      }
    >
      <ModuleButtons
        key={props.routine.id}
        config={props.routine.config}
        currentState={props.state}
        styleOverrides={{
          buttonStyle: props.buttonStyle,
          labelStyle: props.labelStyle,
          buttonIcon: props.buttonIcon,
          buttonIconStyle: props.buttonIconStyle,
          secondaryButtonIcon: props.secondaryButtonIcon,
          leftButtonIcon: props.leftButtonIcon,
        }}
        onClick={async (additionalState: any) =>
          await props.onClick(
            props.routine,
            module,
            props.state,
            additionalState,
            props.workflows
          )
        }
      />
    </View>
  );
};
